import { PER_PAGE } from "../../components/constants";
import { ADMIN_REPORTS_DATA , OPEN_LOADER, CLOSE_LOADER, RESET_REPORTS_DATA } from "../actions/reportAction";
const initialState = {
  reportData: {
    totalStudents:[],
    paymentCompleted:[],
    paymentDue:[]
  },
  pagination: {
    perPage: PER_PAGE,
    totalItems: 0,
    currentPage: 0,
    totalPages:0
  },
};

export const reportReducer = (state=initialState, action) => {
  switch (action.type) {
    case ADMIN_REPORTS_DATA:
      return {
        ...state,
        reportData: {
          totalStudents : state.reportData.totalStudents.concat(action.payload.totalStudents),
          paymentCompleted : state.reportData.paymentCompleted.concat(action.payload.paymentCompleted),
          paymentDue : state.reportData.paymentDue.concat(action.payload.paymentDue)
        },
        pagination:{
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
          currentPage: action.payload.currentPage,
          perPage:PER_PAGE
        }
      };
      case OPEN_LOADER:
        return {
          ...state,
          loader: action.payload,
        };
      case CLOSE_LOADER:
        return {
          ...state,
          loader: action.payload,
        };
      case RESET_REPORTS_DATA:
          return {
            ...state,
            reportData: action.payload,
            pagination:{
              totalItems: 0,
              totalPages: 0,
              currentPage: 0,
              perPage:PER_PAGE
            }
          };
    default:
      return state;
  }
};
